import React from "react";
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';

import { Sidebar } from "../Sidebar/Sidebar";
import { Header } from "../Header/Header";
import { Outlet } from "react-router-dom";

import "./MainLayout.css";
import MessagePrompt from "../Common/MessagePrompt/MessagePrompt";
import { useMessage } from "../Common/MessageContext/MessageContext";
import Footer from "../Footer/Footer";
import { useAuth } from "../../services/AuthContext";
import { Typography } from "@mui/material";

const drawerWidth = 240;

export function MainLayout() {
    const { open, message, severity, handleClose } = useMessage();
    const [openDrawer, setOpenDrawer] = React.useState(true);
    const loginContext = useAuth();
    
    const toggleDrawer = () => {
      setOpenDrawer(!openDrawer);
    };

    return (
        <Box sx={{ 
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh'
        }}>
            <CssBaseline />
            <Box sx={{ 
                display: 'flex',
                flex: 1 // This makes the content area grow
            }}>
                <Sidebar drawerWidth={drawerWidth} open={openDrawer} toggleDrawer={toggleDrawer}  />
                <Box
                    component="main"
                    sx={{
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[900],
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'auto',
                    }}
                    >
                    <Header drawerWidth={drawerWidth} open={openDrawer} setOpen={setOpenDrawer} toggleDrawer={toggleDrawer} />
                    <Toolbar />
                    <Container maxWidth="lg" sx={{ mt: 2, mb: 4, flex: 1 }}>
                        {loginContext.isAdmin === "false" && (
                            <Box
                                sx={{
                                    color: 'text.secondary',
                                    lineHeight: 1.6,
                                    mb: 2,  // Margin bottom
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-end', // Right alignment
                                    textAlign: 'right', // For text elements
                                }}
                                >
                                {loginContext.forename && loginContext.surname ? (
                                    <>
                                        {/* Welcome line with larger text */}
                                        <Typography 
                                            component="h1"
                                            variant="subtitle1"
                                            sx={{
                                            fontSize: '1rem',
                                            fontWeight: 500,
                                            color: 'text.primary',
                                            }}
                                        >
                                            Welcome {loginContext.forename} {loginContext.surname}
                                        </Typography>
                                    </>
                                ) : (
                                    <>
                                        {/* Welcome line with larger text */}
                                        <Typography 
                                            component="h1"
                                            variant="subtitle1"
                                            sx={{
                                            fontSize: '1rem',
                                            fontWeight: 500,
                                            color: 'text.primary',
                                            }}
                                        >
                                            Welcome {loginContext.userName}
                                        </Typography>
                                    </>
                                )}   
                                
                                {loginContext.empNo && loginContext.ppsNumber && (
                                    <Box
                                        component="div"
                                        sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: 1,
                                        alignItems: 'center',
                                        fontSize: '0.875rem',
                                        }}
                                    >
                                        {loginContext.empNo && (
                                            <>
                                                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                                                <Typography component="span" sx={{ fontWeight: 600, mr: 0.5 }}>
                                                    Payroll Ref:
                                                </Typography>
                                                <Typography component="span">{loginContext.empNo}</Typography>
                                                </Box>
                                            
                                                <Box component="span" sx={{ color: 'divider' }}>|</Box>
                                            </>
                                        )}
                                        
                                        
                                        {loginContext.ppsNumber && (
                                            <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                                            <Typography component="span" sx={{ fontWeight: 600, mr: 0.5 }}>
                                                PPS:
                                            </Typography>
                                            <Typography component="span">{loginContext.ppsNumber}</Typography>
                                            </Box>
                                        )}
                                    </Box>
                                )}

                                {loginContext.pensionScheme && (
                                    <>
                                        {/* Scheme line */}
                                        <Box
                                            component="div"
                                            sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            fontSize: '0.875rem',
                                            }}
                                        >
                                            <Typography component="span" sx={{ fontWeight: 600, mr: 0.5 }}>
                                            Pension Scheme:
                                            </Typography>
                                            <Typography component="span">{loginContext.pensionScheme}</Typography>
                                        </Box>
                                    </>
                                )}
                            </Box>
                        )}

                        <Outlet />
                        <MessagePrompt
                            open={open} 
                            handleClose={handleClose} 
                            message={message} 
                            severity={severity} 
                        />
                    </Container>
                    <Footer />
                </Box>
            </Box>
        </Box>
    )
}